import { useState } from 'react';
import { Eye, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { setViewAs, usePermissions } from '@/api/permissions';

/** Shown while an admin is viewing Cosmos as another role (Settings → Users & roles → View as this role). */
export function ViewAsBanner() {
  const perms = usePermissions();
  const [busy, setBusy] = useState(false);
  if (!perms?.viewAs) return null;
  const stop = () => {
    setBusy(true);
    setViewAs(null).catch((e) => { setBusy(false); toast.error(e instanceof Error ? e.message : 'Could not stop'); });
  };
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-warning/30 bg-warning-soft px-4 py-1.5 text-xs text-warning">
      <Eye className="h-3.5 w-3.5 shrink-0" />
      <span className="min-w-0 flex-1">
        Viewing Cosmos as <b>{perms.viewAs.roleName}</b>. Menus, pages and what the server allows all follow this role.
        Changes you make still happen, as you.
      </span>
      <Button size="sm" variant="outline" className="h-6 border-warning/40 px-2 text-xs" disabled={busy} onClick={stop}>
        {busy && <Loader2 className="h-3 w-3 animate-spin" />} Stop viewing
      </Button>
    </div>
  );
}
